import { useMemo } from 'react'
import { FC } from 'react'
import { SegmentButton } from 'components/features/pfm/SegmentButton/SegmentButton'
import FollowIcon from 'icons/follow.svg'
import { AnalyticsEvent } from 'interfaces/analytics'

type PostFollowButtonProps = {
  counter?: number
  pressed: boolean
  hideIcon?: boolean

  onClick?: () => void
}

export const PostFollowButton: FC<PostFollowButtonProps> = (props) => {
  const { hideIcon, counter, pressed, onClick } = props

  let contentChild = (
    <>
      { !hideIcon && (
        <SegmentButton.Icon size={ 14 } src={ FollowIcon } />
      )}
      <SegmentButton.Text text='Followed' />
    </>
  )

  if (!pressed) {
    contentChild = (
      <>
        { !hideIcon && (
          <SegmentButton.Icon size={ 14 } src={ FollowIcon } />
        )}
        <SegmentButton.Text text='Follow' />
      </>
    )
  }

  const analyticsAction = useMemo<AnalyticsEvent>(() => ({
    category: 'module-feed_post',
    action: 'toggle-follow',
    label: pressed ? 'unfollow' : 'follow',
  }), [pressed])

  return (
    <SegmentButton
      pressed={ pressed }
      counter={ counter }
      analyticsAction={ analyticsAction }
      onClick={ onClick }
    >
      <SegmentButton.Segment>
        { contentChild }
      </SegmentButton.Segment>
    </SegmentButton>
  )
}
